import { render, staticRenderFns } from "./SearchbarMenuItem.vue?vue&type=template&id=c32d52f4"
import script from "./SearchbarMenuItem.vue?vue&type=script&lang=ts"
export * from "./SearchbarMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports